import AttachmentItemPill from '@intercom/embercom-composer/components/attachment-item-pill';
export default AttachmentItemPill;
